export default {
	inHome: 'in-home',
	retail: 'retail',
	buyOnline: 'buy-online',
	international: 'international',
}
